const style = {
  wrapper: {
    marginBottom: `15px`
  },
  topBox: {
    background: `#f8f8f8`,
    border: `1px solid #666`,
    padding: `20px`
  },
  commentBox: {
    border: `1px solid #666`,
    // border: `1px solid #f8f8f8`,
    borderTop: `0px`
  },
  value: {
    display: `block`,
    textAlign: `center`,
    fontSize: `50px`,
    fontWeight: 400,
    lineHeight: `50px`
  },
  label: {
    display: `block`,
    textAlign: `center`,
    fontSize: `16px`,
    fontWeight: 300,
    paddingTop: `6px`
  },
  commentLabel: {
    fontSize: `13px`,
    fontWeight: 300
  },
  p: {
    fontSize: `14px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/Application/Main/style/ColorBlind/approval.js